import styled from 'styled-components';

export const StyledForm = styled.form`
  width: 100%;
  max-width: 28rem;
  z-index: var(--z-dropdown);
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  overflow: clip;
`;
